module.exports = __webpack_public_path__ + "static/logo-694a055a0c3ca4fa549cf0980d4e5d17.png";